import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20amber%20cream%20and%20terracotta%20tones%2C%20flowing%20organic%20shapes%2C%20ethereal%20light%20rays%2C%20minimalist%20elegant%20composition%2C%20educational%20knowledge%20theme%2C%20no%20text%20no%20letters%2C%20blurred%20dreamy%20atmosphere%2C%20high-end%20editorial%20quality&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            SM专业指南
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-3 text-white/80">
              全面解析SM的含义与应用
            </span>
          </h1>
          <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            深度解析SM的核心概念、类型分类、安全准则与实践要点，帮助对SM感兴趣的用户全面了解SM的知识体系，建立正确认知，安全负责地探索SM相关内容。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/sm-basics"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始学习
            </Link>
            <Link
              to="/category/safety-guidelines"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-lg font-medium text-base whitespace-nowrap hover:bg-white/25 transition-colors cursor-pointer"
            >
              安全准则
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { num: '10+', label: '深度文章' },
              { num: '5', label: '知识分类' },
              { num: 'SSC', label: '安全准则' },
              { num: '100%', label: '免费阅读' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white">{stat.num}</div>
                <div className="text-white/60 text-xs md:text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}